module.exports = __webpack_public_path__ + "b24e87d5/img/placeholder.888fcd0b.svg";